import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

interface SidebarButtonProps {
  icon: React.ReactNode;
  label: string;
  path: string;
  isMinimized: boolean;
  primaryColor: string;
  primaryColorHover: string;
  getBasePath: () => string;
  onNavigate?: () => void;
}

export const SidebarButton: React.FC<SidebarButtonProps> = ({
  icon,
  label,
  path,
  isMinimized,
  primaryColor,
  primaryColorHover,
  getBasePath,
  onNavigate,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive =
    location.pathname === `${getBasePath()}${path}` ||
    (path === "/dashboard" &&
      (location.pathname === getBasePath() ||
        location.pathname === `${getBasePath()}/dashboard`));

  const handleMouseEnter = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!isActive) {
      e.currentTarget.style.backgroundColor = primaryColorHover;
      e.currentTarget.style.color = "#fff";
    }
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!isActive) {
      e.currentTarget.style.backgroundColor = "transparent";
      e.currentTarget.style.color = "#D1D5DB";
    }
  };

  const handleClick = () => {
    if (path === "/dashboard") {
      navigate(`${getBasePath()}/dashboard`);
    } else {
      navigate(`${getBasePath()}${path}`);
    }
    // Close mobile menu after navigation
    if (onNavigate) {
      onNavigate();
    }
  };

  return (
    <button
      className={`${
        isMinimized
          ? "w-12 h-12 mx-auto flex items-center justify-center rounded-full"
          : "w-full flex items-center gap-2 sm:gap-3 px-3 sm:px-4 py-2 sm:py-3 rounded-xl"
      } font-medium transition-all duration-200 text-sm sm:text-base ${
        isActive
          ? "text-white border-l-4"
          : "text-gray-300 hover:bg-[#2D3748]"
      }`}
      style={{
        backgroundColor: isActive ? primaryColorHover : "transparent",
        borderLeftColor: isActive ? primaryColor : "transparent",
        color: isActive ? "#fff" : "#D1D5DB",
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
      title={isMinimized ? label : undefined}
    >
      <span
        className="flex items-center text-base sm:text-lg [&>.MuiSvgIcon-root]:text-[1.25rem]"
        style={isActive ? { color: primaryColor } : undefined}
      >
        {icon}
      </span>
      {!isMinimized && <span className="truncate">{label}</span>}
    </button>
  );
};
